export enum NoteTypes {
    Unknown = 0,
    Standard = 1,
    Requirement = 2,
    Decision = 3,
    SubRequirement = 4,
}
export const NoteTypeIdMap = new Map(Object.values(NoteTypes).map(x => [x.toString(), x]));